export const config = {
    apiUrl: import.meta.env.VITE_API_URL,
    hotelAlias: import.meta.env.VITE_HOTEL_ALIAS,
    sberLoginAppUrl: import.meta.env.VITE_SBER_LOGIN_APP_URL,

    sber_base_url: import.meta.env.VITE_SBER_BASE_URL,
    sber_client_id: import.meta.env.VITE_SBER_CLIENT_ID,
    sber_id_scope: import.meta.env.VITE_SBER_ID_SCOPE,
}
